/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import VerifyEmail from '@/views/VerifyEmail'
import EmailVerification from '@/views/EmailVerification'
import Signup from '@/views/Signup'
import Login from '@/views/Login'
import Home from '@/views/Home'
import Releases from '@/views/Releases'
import ContactUs from '@/views/ContactUs'
import Submission from '@/views/Submission'
import HyperLink from '@/views/HyperLink'
import Information from '@/views/Information'
import store from '../store.js'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login',
        cannotAccessWhileLoggedIn: true,
        requiresAuth: false,
        requiresEmailVerified: false
      }
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      meta: {
        title: 'Signup',
        cannotAccessWhileLoggedIn: true,
        requiresAuth: false,
        requiresEmailVerified: false
      }
    },
    {
      path: '/verify/email',
      name: 'VerifyEmail',
      component: VerifyEmail,
      meta: {
        title: 'VerifyEmail',
        requiresAuth: true,
        requiresEmailVerified: false
      }
    },
    {
      path: '/email/verification/:id/:hash',
      name: 'EmailVerification',
      component: EmailVerification,
      meta: {
        title: 'EmailVerification',
        requiresAuth: true,
        requiresEmailVerified: false
      }
    },
    {
      path: '/submission',
      name: 'Submission',
      component: Submission,
      meta: {
        title: 'Submission',
        requiresAuth: false,
        requiresEmailVerified: true
      }
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Home',
        requiresAuth: false,
        requiresEmailVerified: false
      }
    },
    {
      path: '/releases',
      name: 'Releases',
      component: Releases,
      meta: {
        title: 'Releases',
        requiresAuth: false,
        requiresEmailVerified: false
      }
    },
    {
      path: '/contact',
      name: 'ContactUs',
      component: ContactUs,
      meta: {
        title: 'Contact Us',
        requiresAuth: false,
        requiresEmailVerified: false
      }
    },
    {
      path: '/hyperlink',
      name: 'HyperLink',
      component: HyperLink,
      meta: {
        title: 'HyperLink',
        requiresAuth: false,
        requiresEmailVerified: false
      }
    },
    {
      path: '/information',
      name: 'Information',
      component: Information,
      meta: {
        title: 'Information',
        requiresAuth: false,
        requiresEmailVerified: false
      }
    },
    { path: '*', redirect: '/' }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.cannotAccessWhileLoggedIn)) {
    if (store.getters.isLoggedIn) {
      router.push('/')
      return
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next('/login')
      // next('/login?next=' + to.fullPath)
      return
    }
  }
  if (to.matched.some(record => record.meta.requiresEmailVerified)) {
    if (store.getters.isLoggedIn && !store.getters.isEmailVerified) {
      if (router.currentRoute.path !== '/verify/email') { router.push('/verify/email') }
      return
    }
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js